import { Currency } from '@/core/currency/interfaces';

const IQD: Currency = {
    name: 'Iraqi Dinar',
    demonym: 'Iraqi',
    majorSingle: 'Dinar',
    majorPlural: 'Dinars',
    codeNumeric: '368',
    symbol: 'د.ع.',
    symbolNative: 'د.ع.',
    minorSingle: 'Fils',
    minorPlural: 'Fils',
    ISOdigits: 3,
    decimals: 3,
    numToBasic: 1000,
    code: 'IQD',
    delimiters: {
        thousands: '.',
        decimal: ','
    }
};

export default IQD;
